/** @jsx jsx */
import React from "react";
import { jsx, Flex, Container  } from "theme-ui";
import GridItem from "./GridItem";
import BulletListItem from "./BulletListItem";
import CardItem from "../../shared/CardItem";
import RichTextSection from "../richTextSection";
import { useHubSpotScript } from "../../../hooks/useHubSpotScript";

// eslint-disable-next-line consistent-return
const GenerateGridItems = ({ gridItem, maxColumns, textColor, classname }) => {
  const { __typename } = gridItem;

  switch (__typename) {
    case "ContentfulGridItem":
      return <GridItem gridItem={gridItem} maxColumns={maxColumns} textColor={textColor} classname={classname}/>;
    case "ContentfulBulletListItem":
      return <BulletListItem gridItem={gridItem} />;
    case "ContentfulCardItem":
      return <CardItem gridItem={gridItem} sx={{ maxWidth: "404px" }} className='card-item'/>;
    case "ContentfulRichTextSection":
      return (
        <Flex sx={{ flexDirection: ["column"], justifyContent: 'normal !important', gap: '40px' }} className="grid-item">
          <RichTextSection sectionContent={gridItem} />
        </Flex>);
    case "ContentfulHubspotForm":
      useHubSpotScript(gridItem.slug, gridItem.region, gridItem.portalId, gridItem.formId);
      return (
        <Flex sx={{ flexDirection: ["column"]}} className="grid-item hsform-incontent">
          <Container>
            <div sx={{ marginTop: '1em auto', fontFamily: 'Source Sans Pro,sans‑serif' }} id={gridItem.slug}></div>
          </Container>
        </Flex>);
    default:
      break;
  }
};

export default GenerateGridItems;
